// @ts-check

/** @type import("../../types/themes").AliasGenerator */
const aliases = (palette) => ({
  background: {
    dark: palette.gray["900"],
    default: palette.gray["000"],
    faint: palette.gray["100"],
    light: palette.gray["000"],
    strong: palette.gray["200"],
  },
  border: {
    default: palette.gray["300"],
    strong: palette.gray["500"],
  },
  chart: {
    "01": {
      ...palette.blue,
      default: palette.blue["500"],
    },
    "02": {
      ...palette.orange,
      default: palette.orange["500"],
    },
    "03": {
      ...palette.mint,
      default: palette.mint["500"],
    },
    "04": {
      ...palette.magenta,
      default: palette.magenta["500"],
    },
    "05": {
      ...palette.gray,
      default: palette.gray["500"],
    },
    "06": {
      ...palette.purple,
      default: palette.purple["400"],
    },
    "07": {
      ...palette.yellow,
      default: palette.yellow["400"],
    },
    "08": {
      ...palette.pink,
      default: palette.pink["400"],
    },
    "09": {
      ...palette.azure,
      default: palette.azure["400"],
    },
    "10": {
      ...palette.teal,
      default: palette.teal["400"],
    },
  },
  outline: {
    focus: palette.blue["600"],
    focusAlternative: palette.gray["000"],
    hover: `color-mix(in srgb, ${palette.gray["000"]} 50%, transparent)`,
  },
  overlay: {
    default: palette.gray["000"],
    light: palette.gray["000"],
    dark: palette.gray["999"],
  },
  shadow: {
    default: palette.gray["999"],
    light: `0 2px 6px 0 color-mix(in srgb, ${palette.gray["900"]} 10%, transparent)`,
    medium: `0 8px 24px 0 color-mix(in srgb, ${palette.gray["900"]} 20%, transparent)`,
    strong: `0 16px 48px 0 color-mix(in srgb, ${palette.gray["900"]} 33%, transparent)`,
  },
  text: {
    default: palette.gray["900"],
    faint: palette.gray["500"],
    highlight: palette.blue["600"],
    success: palette.green["500"],
    warning: palette.yellow["500"],
    error: palette.red["600"],
    light: palette.gray["000"],
    dark: palette.gray["900"],
    placeholder: palette.gray["500"],
  },
  neutral: {
    ...palette.gray,
    default: palette.gray["500"],
  },
  success: {
    ...palette.green,
    default: palette.green["500"],
  },
  error: {
    ...palette.red,
    default: palette.red["500"],
    faint: palette.red["300"],
  },
  warning: {
    ...palette.yellow,
    default: palette.yellow["500"],
  },
  info: {
    ...palette.blue,
    default: palette.blue["600"],
  },
  highlight: {
    ...palette.blue,
    default: palette.blue["600"],
  },
});

export default aliases;
